import React from 'react'
import bgImage from '../../assets/servicesImages/swt/hero.png'
import swt from '../../assets/servicesImages/swt/swt.png'
import pic1 from '../../assets/servicesImages/swt/1.png'
import pic2 from '../../assets/servicesImages/swt/2.png'
import pic3 from '../../assets/servicesImages/swt/3.png'
import pic4 from '../../assets/servicesImages/swt/4.png'
import a1 from '../../assets/servicesImages/swt/1a.png'
import b1 from '../../assets/servicesImages/swt/1b.png'
import c1 from '../../assets/servicesImages/swt/1c.png'
import d1 from '../../assets/servicesImages/swt/1d.png'
import i1 from '../../assets/servicesImages/swt/i1.png'
import i2 from '../../assets/servicesImages/swt/i2.png'
import i3 from '../../assets/servicesImages/swt/i3.png'

const item = [
  {
    icon: i1,
    title: 'Test scenario',
    desc: 'Test case scenarios will be listed in a structured manner to ensure end-to-end performance quality is assessed.'
  },
  {
    icon: i2,
    title: 'Phase testing',
    desc: 'The application is tested from various potential perspectives and user scenarios to identify and resolve possible quality issues.'
  },
  {
    icon: i3,
    title: 'Report',
    desc: 'A structured report is shared with developers to resolve the failed test scenarios and a retest is conducted to ensure that each issue is addressed effectively.'
  },
]

const cards = [
  {
    image: pic1,
    title: 'Functional testing',
    desc: 'Functional testing ensures the system operates according to specifications through quality checks and scenario-based validation.'
  },
  {
    image: pic2,
    title: 'Performance testing',
    desc: 'Evaluates system responsiveness and stability under load, using analytics to optimize speed and reliability.'
  },
  {
    image: pic3,
    title: 'Exploratory testing',
    desc: 'Conducts flexible, scenario-based testing with comprehensive coverage focused on user experience and usability.'
  },
  {
    image: pic4,
    title: 'Security testing',
    desc: 'Detects vulnerabilities, performs penetration testing, and strengthens app resilience against malicious threats.'
  }
]

const card = [
  {
    image: a1,
    title: 'Comprehensive quality assessment',
    desc: 'Code quality and functioning capability is tested in detail to ensure the application fulfills all requirements.',
  },
  {
    image: b1,
    title: 'Quality, security, transparency',
    desc: 'We ensure high quality, security, and transparency through accurate, consistent test processes.',
  },
  {
    image: c1,
    title: 'Accelerated delivery',
    desc: 'Rapid delivery timelines with high code quality using advanced tools and automated testing pipelines.',
  },
  {
    image: d1,
    title: 'Maximum coverage',
    desc: 'Tests for cross-device and cross-platform compatibility with maximum functional coverage.',
  }
]

const SWservices = () => {
  return (
    <div className="font-sans text-gray-800">

      
     <div className='h-[40vh] md:h-[50vh] lg:h-screen w-full text-white flex justify-start items-center pt-24 relative bg-cover bg-center'
        style={{ backgroundImage: `url(${bgImage})` }}>
        <div className="absolute inset-0 bg-[rgba(0,0,0,0.45)] z-0"></div>
        <div className='flex flex-col gap-8 px-6 sm:px-12 md:px-20 lg:px-32 z-10 max-w-4xl'>
          <h1 className='text-[20px] sm:text-[20px] md:text-5xl font-bold leading-tight'>
            Software Testing Services
          </h1>
          <p className="text-[16px] sm:text-[16px]  md:text-xl font-light">
            Ensuring Quality and Reliability Through Comprehensive Software Testing Services
          </p>
        </div>
      </div>


      {/* Intro Section */}
      <section className='py-12 px-6 sm:px-12 md:px-20 lg:px-32 bg-gray-100 text-center'>
        <h2 className='text-2xl sm:text-3xl font-semibold text-primary mb-4'>
          Software Testing Services
        </h2>
        <p className='text-base text-gray-700 text-center sm:text-left md:text-justify lg:text-justify'>
  Reliable engineering-led software testing services in Bangalore, India by Esparse Matrix Solutions to help your websites and applications function seamlessly, maximize performance, and enhance scalability.
</p>

      </section>

      {/* Professional Software Testing Services */}
      <section className='py-12 px-6 sm:px-12 md:px-20 lg:px-32'>
        <h2 className='text-2xl sm:text-3xl font-semibold text-center text-primary mb-6'>
          Professional Software Testing Services @ Esparse Matrix Solutions
        </h2>
        <div className='flex flex-col md:flex-row justify-center items-center gap-8'>
          <p className='text-base sm:text-lg text-gray-700 text-justify max-w-xl'>
            At Esparse Matrix Solutions, our expert testers deliver quality-driven software testing to eliminate errors, reduce bugs, and enhance user experiences. We adhere to digital quality assurance standards, providing scalable, robust, and reliable solutions that prevent workflow disruptions.
          </p>
          <img src={swt} alt='Software Testing' className='w-full md:w-[400px] h-auto object-cover rounded-lg shadow-lg' />
        </div>
      </section>

      {/* Testing Types Cards */}
      <section className='py-12 px-6 sm:px-12 md:px-20 lg:px-32 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8'>
        {cards.map((item, idx) => (
          <div key={idx} className="bg-white rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden hover:scale-[1.02] hover:text-blue-900">
            <img src={item.image} alt='service' className='w-full h-[200px] object-cover' />
            <div className='p-6'>
              <h3 className='text-lg font-semibold text-center text-primary'>{item.title}</h3>
              <p className='text-sm text-gray-600 text-center mt-2'>{item.desc}</p>
            </div>
          </div>
        ))}
      </section>

      {/* Key Differentiator Section */}
      <section className='py-12 px-6 sm:px-12 md:px-20 lg:px-32 bg-gray-100 text-center'>
        <h2 className='text-2xl sm:text-3xl font-semibold text-primary mb-4'>
          Key Differentiator
        </h2>
        <p className='text-base sm:text-lg text-gray-700'>
          Our QA and software testing services expedite your testing process by implementing various test case scenarios to detect, analyze, and resolve potential quality issues which might hinder the productivity and performance of the application.
        </p>
      </section>

      {/* Differentiator Cards */}
      <section className='py-12 px-6 sm:px-12 md:px-20 lg:px-32 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8'>
        {card.map((item, idx) => (
          <div key={idx} className="bg-white rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-[1.02] hover:text-blue-900">
            <img src={item.image} alt='differentiator' className='w-full h-[200px] object-cover' />
            <div className='p-6'>
              <h3 className='text-lg font-semibold text-center text-primary'>{item.title}</h3>
              <p className='text-sm text-gray-600 text-center mt-2'>{item.desc}</p>
            </div>
          </div>
        ))}
      </section>

      {/* QA Solutions Section */}
      <section className='py-12 px-6 sm:px-12 md:px-20 lg:px-32'>
        <h2 className='text-2xl sm:text-3xl font-semibold text-center text-primary mb-6'>
          Software Testing and QA Solutions
        </h2>
        <div className='flex flex-wrap justify-center gap-8'>
          {item.map((item, idx) => (
            <div key={idx} className="bg-white rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 w-full sm:w-[300px] md:w-[280px] p-6 hover:scale-[1.02] hover:text-blue-900">
              <img src={item.icon} alt="icon" className='w-[60px] h-[60px] mb-4 mx-auto' />
              <h3 className='text-lg font-semibold text-center text-primary'>{item.title}</h3>
              <p className='text-sm text-gray-600 text-center mt-2'>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default SWservices;
